
import _memoize from "lodash/memoize"
import log from "plugins/loglevel/index"

import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

import DataRetriever from "app/data_retriever"
import { gtag } from "app/tracking/google/google_analytics_4/gtag"

const LOGGING_PREFIX = "[App.Tracking.Google.PageView.track]"
// Doc might not be ready on JS execution
const getGoogleAnalyticsTrackerName = _memoize(() => {
  const name = DataRetriever.get("google-analytics-tracker-name")

  if (typeof name !== "string" || name.length === 0){
    return null
  }
  return name
})

/*
 * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
 *
 * @param {string} path_path - Must start with slash
 * @param {object} options
 */
const track = (page_path: string, options = {}): void => {
  if ( ! /^\//.test(page_path) ){
    log.warn("page_path does NOT start with slash")
    return
  }

  const debug_message_fragments = [
    LOGGING_PREFIX,
    "about to track PageView with:",
    `page_path: [${page_path}]`,
  ]

  log.debug(debug_message_fragments.join(" "))

  // UA implementation
  WaitObjectByPathPromise("ga")
  .then((ga) => {
    const final_options = Object.assign({}, {
      hitType:  "pageview", // Required.
      page:     page_path,  // Required.
    }, options)
    const tracker_name = getGoogleAnalyticsTrackerName()

    if (tracker_name == null){
      ga("send", final_options)
    }
    else{
      ga(`${tracker_name}.send`, final_options)
    }

    log.debug(`${LOGGING_PREFIX} PageView tracked`)
    log.debug(`page_path: ${page_path}`)
  })
  .catch(() => {
    log.warn("ga is undefined!")
  })

  // GA4 implementation
  //
  // `page_view` doc:
  // https://developers.google.com/tag-platform/gtagjs/reference/events#page_view
  //
  // window.location should be used instead of following:
  // `${window.location.protocol}//${window.location.host}/${page_path}`
  gtag("event", "page_view", {
    page_location: window.location,
  })
}

export default { track }
export { track }
